/** Parse the URL hash as query params (Supabase auth redirects use `#access_token=…&type=recovery`). */
export function parseHashParams(): URLSearchParams {
  const raw = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  return new URLSearchParams(raw);
}

export function isRecoveryHash(): boolean {
  return parseHashParams().get('type') === 'recovery';
}

/** Remove Supabase auth tokens from the URL without reloading. */
export function clearAuthHash(): void {
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
}

/** Redirect target for password-reset emails — must match Supabase allowed redirect URLs. */
export function authRedirectUrl(): string {
  return `${window.location.origin}${window.location.pathname}`;
}
